import { isNil } from 'lodash';
export const eq =
  <T>(compare: T) =>
  (val: T) =>
    compare === val;
export const notEq =
  <T>(compare: T) =>
  (val: T) =>
    compare !== val;

export const nil = <T>(val: T | undefined | null) => isNil(val);
export const notNil = <T>(val: T | undefined | null): val is T => !nil(val);

export const nilWith =
  <T, U>(fn: (v: T) => U) =>
  (v: T | undefined | null) =>
    notNil(v) ? fn(v) : v;
export const nilElseWith =
  <T, U>(def: U, fn: (v: T) => U) =>
  (v: T | undefined | null) =>
    notNil(v) ? fn(v) : def;

/**
 * Return first argument that is neither null nor undefined
 */
export const co = <T>(...args: Array<T | null | undefined>): T =>
  args.find(notNil) as T; // TODO: Is this actually guaranteed? What if all args are null/undefined?

/**
 * Return first argument that is neither null nor undefined or return the default (curried)
 */
export const cco =
  <T>(...args: Array<T | null | undefined>) =>
  (d: T) => {
    const init = args.find(notNil);
    return notNil(init) ? init : d;
  };

/**
 * Curried ternary operator
 * (comparator)(true)(false)(value)
 */
export const tern =
  <T, U, V>(compare: T) =>
  (then: U) =>
  (el: V) =>
  (val: T) =>
    eq(compare)(val) ? then : el;
